export default __webpack_public_path__ + "static/media/bears_black.2134e7b3.png";